var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Events = OCS.Events || {};
OCS.Classes.OCSEvent = new Class({
    Implements: [Options, Events, new Class(OCS.Interfaces.UniqueId)],
    class_type: "OCSEvent",
    class_name: "OCSEvent",
    callback_fired_timeout: null,
    delayed_event_timeouts: [],
    delayed_event_names: [],
    delayed_event_data: [],
    options: {
        data_name: 'OCS_event_manager',
        debug: false,
        event_namespace: '.OCS_event_manager',
        event_name: '',
        list_data_name: 'event_to_callback_id',
        specific_event: false, // Turning this to true means its not a global event and will not be stored for global use
        prevent_default: false,
        stop_propagation: false,
        fire_immediately: false,
        once: false
    },
    last_callback_id: "",
    callbacks: {},
    callback_data: null,
    callback_e: null,
    item: null,
    bound_methods: {},
    initialize: function (op) {
        if (!op || typeof op !== "object") {
            return false;
        }
        if (!op.specific_event && OCS.Events[op.event_name]) {
            var event_obj = OCS.Events[op.event_name];
            // This is a pre-existing event, but we may need to append to it
            event_obj.process_new_callback(op);
            return event_obj;
        }

        this.bound_methods.on_dom_event = this.on_dom_event.bind(this);
        this.bound_methods.on_event = this.on_event.bind(this);
        var item = this.get_item_from_ops(op);
        this.setOptions(op);
        this.process_new_callback(op);
        if (this.options.event_name && this.options.event_name !== '' && this.options.event_name.length) {
            if (item) {
                this.set_item(item);
            } else {
                this.addEvent(this.options.event_name, this.bound_methods.on_event);
            }
            if (!this.options.specific_event) {
                OCS.Events[this.options.event_name] = this;
            }
        }

        var em = new OCS.Classes.OCSEventManager();
        this.bound_methods.destroy = this.destroy.bind(this);
        em.addEvent('destroy', this.bound_methods.destroy);

    },

    /*
     * 
     * Actions
     * 
     */

    activate_event_callbacks: function (data, e) {
        this.callback_data = data;
        this.callback_e = e;
        if (this.options.fire_immediately) {
            this.fire_event_callbacks();
        } else {
            if (!this.callback_fired_timeout) {
                this.callback_fired_timeout = setTimeout(function () {
                    this.callback_fired_timeout = null;
                    this.fire_event_callbacks();
                }.bind(this), 0);
            }
        }

    },
    /**
     * event - Fires an event either delayed or immediately
     * @param {String} event
     * @param {String|Number|Boolean|Array|Object} data
     * @param {Number} delay
     * @return {undefined}
     */
    event: function (event, data, delay) {
        if (delay) {
            this.delayed_event_names.push(event);
            this.delayed_event_data.push(data);
            this.delayed_event_timeouts.push(setTimeout(this.delayed_event_processor.bind(this), delay));
        } else {
            this.fireEvent(event, data);
        }
    },
    delayed_event_processor: function () {
        if (this.delayed_event_names.length && this.delayed_event_data.length) {
            this.fireEvent(this.delayed_event_names.shift(), this.delayed_event_data.shift());
        }
    },

    fire_event_callbacks: function () {
        var callbacks = this.callbacks;
        var data = this.callback_data;
        var e = this.callback_e;
        this.callback_data = null;
        this.callback_e = null;
        Object.each(callbacks, function (callback) {
            try {
                callback(data, e);
            } catch (err) {
                console.warn("OCS.Classes.OCSEvent:", err);
            }
        });
        if (this.options.once) {
            this.destroy();
        }
    },
    /**
     * @method add_callback_ids
     * @param {Function} callback
     * @param {Function} callback_id
     */
    add_callback: function (callback, callback_id) {
        if (!callback_id) {
            callback_id = this.create_unique_id();
        }
        this.last_callback_id = callback_id;
        if (!this.callbacks[callback_id]) {
            this.callbacks[callback_id] = callback;
        }
    },
    process_new_callback: function (op) {
        if (op && op.callback) {
            var callback_id;
            if (op.callback_id) {
                callback_id = op.callback_id;
                delete op.callback_id;
            }
            this.add_callback(op.callback, callback_id);
            delete op.callback;
        }
    },
    remove_callback: function (callback_id) {
        if (callback_id && this.callbacks[callback_id]) {
            delete this.callbacks[callback_id];
        }
    },
    unsubscribe_dom: function () {
        // This means we unsubscribing from all the events attached to this dom.
        if (this.item) {
            this.item.unbind(this.options.event_name + this.options.event_namespace);
        }
    },

    /*
     * 
     * Event Listeners
     * 
     */
    on_event: function (data) {
        this.activate_event_callbacks(data);
    },
    on_dom_event: function (e, data) {
        if (this.options.prevent_default && e.preventDefault) {
            e.preventDefault();
        }
        if (this.options.stop_propagation && e.stopPropagation) {
            e.stopPropagation();
        }
        this.activate_event_callbacks(data, e);
    },
    listen_at_dom: function () {
        if (this.item && this.item.length && this.options.event_name) {
            this.item.bind(this.options.event_name + this.options.event_namespace, this.bound_methods.on_dom_event);
        }
    },

    /*
     * 
     * Get / Set Methods
     * 
     */
    get_item: function () {
        return this.item;
    },
    get_item_from_ops: function (ops) {
        var item;
        if (ops && ops.hasOwnProperty('item')) {
            item = ops.item;
            delete ops.item;
        }
        if (ops && ops.hasOwnProperty('selector')) {
            if (ops.hasOwnProperty('context')) {
                item = jQuery(ops.selector, jQuery(ops.context));
            } else {
                item = jQuery(ops.selector);
            }
        }
        return item;
    },
    get_last_callback_id: function () {
        return this.last_callback_id;
    },
    set_item: function (item) {
        if (this.item) {
            this.unsubscribe_dom();
            this.item.data(this.class_name, null);
        }
        this.item = jQuery(item);
        this.listen_at_dom();

    },

    /*
     * Destroy Method
     */
    destroy: function () {
        this.unsubscribe_dom();
        if (this.callback_fired_timeout) {
            clearTimeout(this.callback_fired_timeout);
            this.callback_fired_timeout = null;
            this.fire_event_callbacks();
        }
        if (this.delayed_event_timeouts.length) {
            this.delayed_event_timeouts.each(function (timeout) {
                clearTimeout(timeout);
            });
            this.delayed_event_timeouts = [];
        }
        this.delayed_event_names = [];
        this.delayed_event_data = [];
        this.callbacks = {};
        delete OCS.Events[this.options.event_name];
        this.fireEvent('destroy', this);

        // Remove destroy event from event manager.
        if (this.bound_methods.destroy) {
            var em = new OCS.Classes.OCSEventManager();
            em.removeEvent('destroy', this.bound_methods.destroy);
        }
        this.options.event_name = '';
        this.removeEvents();
        this.item = null;
    }
});
